export const errors = {
    MISSING_REQUIRED_FIELDS: "Oznaczone pola są wymagane",
    INCORRECT_EMAIL_ADDRESS: "Podany adres email jest nieprawidłowy",
    INCORRECT_PHONE_NUMBER: "Podany numer telefonu jest nieprawidłowy",
    DATE_RANGE_TOO_SMALL: "Minimalny pobyt to 2 noce",
    AT_LEAST_ONE_ADULT: "Wymagana jest minimum jedna osoba dorosła"
}